import React from 'react'

import ChartWidget from './ChartWidget/ChartWidget'

import s from './Graph.scss'


const sensorIds = {
  radiation: 23,
  lightning: 28,
  waterLevel: 29,
}


const Graph = ({ data: { title, subTitle, value, isFetching, graphId } }) => (
  <div className={s.graph}>
    <ChartWidget
      title={title}
      sensorId={sensorIds[graphId]}
    />
  </div>
)


export default Graph
